import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Formik } from 'formik';
import { useCallback } from 'react';
import * as Yup from 'yup';
import { useDispatch } from '../context/DispatchContext';
import Button from '../elements/Button';
import Label from '../elements/Label';
import FormikNumberInput from '../elements/formik/FormikNumberInput';
import FormikOnChange from '../elements/formik/FormikOnChange';
import { headerLabelStyle } from './Header';
import { HeaderContainer } from './HeaderContainer';
const validationSchema = Yup.object().shape({
    zonesNoiseFactor: Yup.number().min(0).required(),
});
const initialValues = {
    zonesNoiseFactor: 1,
};
function Zones2DOptionPanel() {
    const dispatch = useDispatch();
    const handleZonesPicking = useCallback((values) => {
        dispatch({
            type: 'AUTO_ZONES_DETECTION',
            payload: values,
        });
    }, [dispatch]);
    const handleChangeNoiseFactory = useCallback((values) => {
        dispatch({ type: 'CHANGE_ZONES_NOISE_FACTOR', payload: values });
    }, [dispatch]);
    return (_jsx(HeaderContainer, { children: _jsx(Formik, { onSubmit: handleZonesPicking, initialValues: initialValues, validationSchema: validationSchema, children: ({ handleSubmit, isValid }) => (_jsxs(_Fragment, { children: [_jsx(Label, { title: "Noise factor :", htmlFor: "livePreview", style: headerLabelStyle, children: _jsx(FormikNumberInput, { name: "zonesNoiseFactor", style: { width: '50px' }, min: 0 }) }), _jsx(FormikOnChange, { enableValidation: true, onChange: handleChangeNoiseFactory }), _jsx(Button.Done, { onClick: () => handleSubmit(), style: { margin: '0 10px' }, disabled: !isValid, children: "Auto Zones Picking" })] })) }) }));
}
export default Zones2DOptionPanel;
